/* @flow */

import * as React from 'react';

import './signup-form.module.css';
import {SignupCustomHeader} from './signup-custom-header';

type Props = {|
    psPartnerKey: string,
|};

// When a new partner is added to partnerstack, add their partner key here
// TODO: Empty this/add real keys once we have them
const OFFICIAL_PARTNERSTACK_PARTNER_KEYS = ['1234abc', '1234'];

export function SignupReferralHeader(props: Props) {
    if (!OFFICIAL_PARTNERSTACK_PARTNER_KEYS.includes(props.psPartnerKey)) {
        return null;
    }

    return (
        <SignupCustomHeader
            imgSrc={`/client-resources/ns_partnerstack_${props.psPartnerKey}_logo.svg`}
            officialPartner={true}
        />
    );
}
